import React, { useState } from 'react';
import { supabase } from '../supabase';

export default function Footer({ navigate }) {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState('idle'); // idle | loading | done | error

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubStatus('loading');
    const { error } = await supabase.from('mailing_list').insert({ email });
    if (error && error.code !== '23505') {
      setSubStatus('error');
      setTimeout(() => setSubStatus('idle'), 3000);
    } else {
      setSubStatus('done');
      setEmail('');
    }
  };

  const navLinks = [
    { id: 'home', label: 'Home' }, { id: 'about', label: 'About' },
    { id: 'events', label: 'Events' }, { id: 'contact', label: 'Contact' },
    { id: 'join', label: 'Join Us' },
  ];

  return (
    <footer>
      <div className="footer-grid">
        <div className="footer-brand">
          <img src="/echo-logo.png" alt="ECHO" className="footer-brand-logo" />
          <p>An international youth initiative bringing music to students of all ages and backgrounds, run entirely by high school students.</p>
        </div>
        <div className="footer-col">
          <h4>Navigate</h4>
          <ul>
            {navLinks.map(l => (
              <li key={l.id}><a href="#!" onClick={(e) => { e.preventDefault(); navigate(l.id); }}>{l.label}</a></li>
            ))}
          </ul>
        </div>
        <div className="footer-col">
          <h4>Connect</h4>
          <ul>
            <li><a href="https://discord.com/invite/AMQEeW445H" target="_blank" rel="noopener noreferrer">Discord Community</a></li>
            <li><a href="mailto:shareyoursound01@gmail.com">Email Us</a></li>
            <li><a href="https://calendar.app.google/eAWZ5eyK9x3TvDEw7" target="_blank" rel="noopener noreferrer">Schedule a Lesson</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Mailing List</h4>
          <p style={{ color: 'rgba(245,240,232,0.4)', fontSize: '0.82rem', marginBottom: '1rem', lineHeight: '1.6' }}>
            Stay updated on events, competitions, and new opportunities.
          </p>
          {subStatus === 'done' ? (
            <p style={{ color: 'var(--sage)', fontSize: '0.85rem' }}>✓ You're subscribed!</p>
          ) : (
            <form className="footer-mailing-form" onSubmit={handleSubscribe}>
              <input
                type="email" placeholder="your@email.com"
                value={email} onChange={e => setEmail(e.target.value)}
                disabled={subStatus === 'loading'}
              />
              <button type="submit" disabled={subStatus === 'loading'}>
                {subStatus === 'loading' ? '...' : 'Join'}
              </button>
            </form>
          )}
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 Echo Music Tutoring. All rights reserved.</p>
        <div className="footer-socials">
          <a href="https://discord.com/invite/AMQEeW445H" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="Discord">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03z"/></svg>
          </a>
          <a href="mailto:shareyoursound01@gmail.com" className="footer-social-btn" title="Email">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
